import { useState } from 'react';
import { PageHeader } from '@/components/Header/Page/PageHeader';
import { PageInfoHeading } from '@/components/Header/Page/PageInfoHeading';
import {
  useGetAllEmailTemplates,
  useUpdateManyEmailTemplates,
} from '@/hooks/email-template.hooks';
import { useNavigate } from 'react-router-dom';
import { EmailTemplateTableView } from '../components/EmailTemplateTableView';
import { TEmailTemplateSchema } from '@/schemas/email-template/email-template.schema';
import { EmailTemplateTableHeaders } from '../components/EmailTemplateTableHeaders';
import { EmailTemplateTableData } from '../components/EmailTemplateTableData';
import { Trans, useTranslation } from 'react-i18next';
import ConfirmationModal from '@/components/Custom/Modal/ConfirmationModal';
import Modal from '@/components/Modal';
import { useDeactivateField } from '@/hooks/deactivate-field.hooks';
import { HeadingButton } from '@/components/Custom/Button/HeadingButton';
import { WarningMessage } from '@/components/Message/WarningMessage';

export const TemplateEmailListPage = () => {
  const { t } = useTranslation('emailTemplate');
  const navigate = useNavigate();
  const [totalActive, setTotalActive] = useState<number>(0);

  /**
   * === Deactivate Data section ===
   */
  const {
    numberOfItemsToDeactivate,
    pendingDeactivate,
    handleDeactivate,
    onConfirmDeactivate,
  } = useDeactivateField<TEmailTemplateSchema>({
    t,
    useUpdateData: useUpdateManyEmailTemplates,
  });

  const onGetTotalActive = (total: number) => {
    setTotalActive(total);
  };
  /**
   * === END OF Deactivate Data section ===
   */

  return (
    <>
      <PageHeader
        title={t('brevoEmailTemplates')}
        totalItems={totalActive}
        headingElement={<PageInfoHeading text={t('indicateTemplateName')} />}
        actionListElement={
          <>
            <HeadingButton
              text={t('addEmailTemplate')}
              leftIcon={
                <i className="-mt-[1.5px] ki-outline ki-plus-circle !text-[19.4px] text-light-inverse dark-mode:text-gray-600" />
              }
              onClick={() => navigate('/email-template/create')}
            />
          </>
        }
      />
      <div>
        <EmailTemplateTableView<TEmailTemplateSchema>
          t={t}
          useGetAllData={useGetAllEmailTemplates}
          onGetTotalActive={onGetTotalActive}
          tableHeaders={EmailTemplateTableHeaders}
          tableData={EmailTemplateTableData}
          pendingDeactivate={pendingDeactivate}
          onDeactivate={handleDeactivate}
        />
      </div>
      <Modal
        id="information-modal"
        title={t('common:information')}
        centerY
        showCancelBtn={false}
        showSecondBtn={true}
        secondBtnLabel="Ok"
        size="small"
      >
        <WarningMessage message={t('common:unableToDeactivateLinkedItem')} />
      </Modal>
      <ConfirmationModal
        id="deactivation-confirm-modal"
        title={t('common:confirmation')}
        description={
          numberOfItemsToDeactivate > 1 ? (
            <Trans i18nKey="common:confirmDeactivateItems" />
          ) : (
            t('common:confirmDeactivateItem')
          )
        }
        onConfirmLabel={t('common:deactivate')}
        onConfirm={onConfirmDeactivate}
      />
    </>
  );
};
